import React from 'react';
import { motion } from 'framer-motion';
import { MathJaxContext } from 'better-react-mathjax';
import { renderBlocks } from '../components/renderBlocks'; // ✅ Shared renderer

export default function VerticalTimelineQA({ items }) {
  return (
    <MathJaxContext>
      <div className="relative border-l-2 border-indigo-500 ml-6 pl-6">
        {items.map((item, index) => (
          <motion.div
            key={item.id || index}
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="relative mb-10"
          >
            <span className="absolute left-[-31px] top-1 w-4 h-4 bg-indigo-500 rounded-full border-4 border-white"></span>

            <div className="bg-white rounded shadow p-4 border border-gray-200">
              <h4 className="text-indigo-700 font-semibold mb-2">
                Q{item.order_index}
              </h4>

              <div className="text-sm text-gray-800 mb-3">
                {item.question_blocks
                  ? renderBlocks(item.question_blocks)
                  : renderBlocks([{ type: 'text', value: item.question }])
                }
              </div>

              <div className="text-sm text-gray-700">
                <p className="font-semibold mb-1 text-indigo-600">Answer:</p>
                {item.answer_blocks
                  ? renderBlocks(item.answer_blocks)
                  : renderBlocks([{ type: 'text', value: item.answer }])
                }
              </div>

              {item.hint && (
                <p className="mt-2 text-sm text-gray-500">
                  <strong>Hint:</strong> {item.hint}
                </p>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </MathJaxContext>
  );
}
